<div class="food-card" [class.not-selected]="!checked">
  <div class="food-card-header">
    <div class="checkbox-container">
      <input
        type="checkbox"
        [checked]="checked"
        [disabled]="!enabled"
        (click)="onCheckboxClick()"
        [attr.data-testid]="'food-card-checkbox-' + foodType"
      />
    </div>
    <div class="title-badge" [attr.data-testid]="'food-card-badge-' + foodType">
      <img [src]="getIconSrc()" [alt]="getTitle()" />
      <span>{{ getTitle() }}</span>
    </div>
    <button
      class="change-product-button"
      [class.not-selected]="!canInteract()"
      [disabled]="!canInteract()"
      (click)="openChangeProductModal()"
      type="button"
    >
      <i class="bi bi-arrow-repeat"></i><span>Alterar</span>
    </button>
  </div>
  <div class="food-card-body">
    <div class="product-img-container">
      <div class="product-image">
        <img
          [src]="product.product.productImageUrl"
          [alt]="product.product.name"
        />
      </div>
      <button
        class="zoom-image"
        [class.disable-zoom]="!enabled"
        (click)="expandProductInModal()"
        type="button"
      >
        <span>Ampliar</span>
      </button>
    </div>
    <div class="product-info">
      <p
        class="product-name"
        [class.snack-card-name]="!isCompleteFood"
        [attr.data-testid]="'product-name-' + foodType"
      >
        {{ product.product.name }}
      </p>
      <div class="snack-suggested-portion" *ngIf="!isCompleteFood">
        <span>Sugestão</span>
        <div class="portion" [class.not-selected]="!canInteract()">
          <img [src]="getPotionBadgeIconSrc()" [alt]="getTitle()" />
          <span [attr.data-testid]="'premier-suggestion-' + foodType">{{
            getRecommendedPortionAmount('with-label')
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="complete-food-suggested-portion"
    *ngIf="isCompleteFood && !canInteract()"
  >
    <div class="unselected-complete-food-portion">
      <p>
        Selecione o produto para configurar a quantidade de refeições por dia.
      </p>
    </div>
  </div>
  <div
    class="complete-food-suggested-portion"
    *ngIf="isCompleteFood && canInteract()"
  >
    <div class="suggestion-option-container">
      <div class="option-checkbox">
        <img
          src="../../../assets/icons/premierpet-fav-icon.svg"
          alt="Ícone da PremieRpet®"
        />
        <span
          *ngIf="!isRecalculatingValues; else recalculating"
          [attr.data-testid]="'premier-suggestion-' + foodType"
        >
          Sugestão PremieRpet®
          <b>é de {{ getOriginalGramsPerDay('with-label') }}</b>
        </span>
      </div>
      <div class="manual-option-details option-details">
        <div>
          <div class="spinner-input-container">
            <span>Refeições por Dia</span>
            <ng-template
              #spinnerTemplate
              let-value="value"
              let-onChange="onChange"
              let-maxValue="maxValue"
            >
              <div class="spinner-input">
                <button
                  type="button"
                  class="spinner-btn spinner-btn-minus"
                  (click)="decrementValue(value, onChange)"
                  [disabled]="value <= 1"
                >
                  <i class="bi bi-dash"></i>
                </button>
                <input
                  type="number"
                  [value]="value"
                  (input)="onInputChange($event, onChange)"
                  class="spinner-input-field"
                  min="1"
                  [attr.max]="maxValue ?? null"
                />
                <button
                  type="button"
                  class="spinner-btn spinner-btn-plus"
                  (click)="incrementValue(value, onChange, 1, maxValue)"
                  [disabled]="maxValue !== undefined && value >= maxValue"
                >
                  <i class="bi bi-plus"></i>
                </button>
              </div>
            </ng-template>
            <ng-container
              *ngTemplateOutlet="
                spinnerTemplate;
                context: {
                  value: mealsPerDay,
                  onChange: updateMealsPerDay.bind(this),
                  maxValue: 6
                }
              "
            ></ng-container>
          </div>
          <div class="spinner-input-container">
            <span>Gramas por Refeição</span>
            <ng-container
              *ngTemplateOutlet="
                spinnerTemplate;
                context: {
                  value: gramsPerMeal,
                  onChange: updateGramsPerMeal.bind(this)
                }
              "
            ></ng-container>
          </div>
        </div>
        <span class="recommendation-info">
          <i class="bi bi-info-circle-fill"></i>Recomendação total é de
          <b>{{ getRecommendedPortionAmount('with-label') }}</b>
        </span>
      </div>
    </div>
  </div>
  <div class="food-card-footer">
    <a
      class="see-benefits"
      [href]="canOpenBenefits() ? product.product.productUrl : '#'"
      target="_blank"
      [class.disable-see-benefits]="!canOpenBenefits()"
      [style.pointer-events]="!canOpenBenefits() ? 'none' : 'auto'"
    >
      <span>Ver Benefícios</span>
    </a>
  </div>
</div>

<app-generic-nav-drawer #drawer>
  <app-change-product
    *ngIf="drawer.isOpen"
    (closeChange)="drawer.toggleVisibility()"
    [titleProduct]="titleProductToChange"
    [productFilter]="productToChangeFilter"
    [filterKeyProduct]="filterKeyProductToChange"
    (productSelected)="onProductSelected($event)"
    [speciePet]="speciePet"
  >
  </app-change-product>
</app-generic-nav-drawer>

<ng-template #recalculating>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 8px;
    "
  >
    <span style="display: flex; align-items: center">Recalculando...</span>
    <div style="display: flex; align-items: center; justify-content: center">
      <app-generic-loading
        [isLoading]="isRecalculatingValues"
        [size]="16"
        style="display: flex; align-items: center"
      ></app-generic-loading>
    </div>
  </div>
</ng-template>
